import { useCallback, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDispatch } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import PaginationRow from 'components/atoms/GefMui/PaginationRow';
import fetch from 'features/common/fetch';
import {
	fetchBruttoProduction,
	loadMoreBruttoProduction,
	loadPageBruttoProduction,
	reloadBruttoProduction,
} from 'features/views/dashboard/statistics/actions';

import BruttoProductionTableBody from './BruttoProductionTableBody';
import BruttoTablePeriodToggle from './BruttoTablePeriodToggle';

export const BruttoTable = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchBruttoProduction());
	}, [dispatch]);

	const handleLoadMore = useCallback(() => {
		dispatch(loadMoreBruttoProduction());
	}, [dispatch]);

	const handlePaginationClick = useCallback(
		(e, page) => {
			dispatch(loadPageBruttoProduction(page - 1));
		},
		[dispatch],
	);

	const handleReload = useCallback(() => {
		dispatch(reloadBruttoProduction());
	}, [dispatch]);

	return (
		<ComponentLoader
			fetchStorePath={fetch.constants.urls.bruttoProduction}
			forceInlineError
			onReload={handleReload}
		>
			<Stack spacing={2}>
				<BruttoTablePeriodToggle />
				<Paper sx={{ p: 3, backgroundColor: (theme) => theme.palette.background[100], borderRadius: 1 }}>
					<Paper sx={{ borderRadius: 2 }}>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell align="left">{getMessage('dashboard:statistics.seller')}</TableCell>
									<TableCell align="left">
										{getMessage('dashboard:statistics.bruttoProductionAndTeamActivities')}
									</TableCell>
									<TableCell align="center">
										{getMessage('dashboard:statistics.newPoliciesCount')}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<BruttoProductionTableBody />
								<PaginationRow
									colSpan={100}
									fetchStorePath={fetch.constants.urls.bruttoProduction}
									onLoadNext={handleLoadMore}
									onPaginationClick={handlePaginationClick}
								/>
							</TableBody>
						</Table>
					</Paper>
				</Paper>
			</Stack>
		</ComponentLoader>
	);
};

export default BruttoTable;
